export default __webpack_public_path__ + "36b8b93.png";